import { delay, call, takeLatest, all, fork, put } from 'redux-saga/effects';

import { SpiService } from '../service/spi/SpiService';
import { getTerminalAddress } from '../service';
import { showErrorSaveRecord } from '../../sagas/sagasCommon';
import { clearFormMessages } from '../../actions/actionCreatorsAdmin';

export default function* (app) {
  return yield all([fork(validateSerialNumber, app)]);
}

function* validateSerialNumber(app) {
  yield takeLatest('@@spi/VALIDATE_SERIAL_NUMBER', callValidateSerialNumber, app);
}

function* callValidateSerialNumber() {
  try {
    const spiService = SpiService.getInstance();
    yield delay(500);
    if (spiService._spi) {
      const result = yield call(getTerminalAddress, spiService._spi);
      if (!result) {
        throw new Error(
          'Invalid serial number. Please contact your administrator'
        );
      } else {
        yield put(clearFormMessages());
      }
    }
  } catch (e) {
    yield showErrorSaveRecord(e);
  }
}
